module.exports = __webpack_public_path__ + "static/img/boy.c6be023.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mycenter/boy.png
// module id = E+Y4
// module chunks = 0